import HomeHeader from "./sections/header/HomeHeader";
import "./css/home.css"
import Pictures from "./sections/pictures/Pictures";

const Home = () => {
    return (
        <main className="home">
            <HomeHeader/>
            <Pictures/>
        </main>
    )
};

export default Home;